
import React from 'react';
import { useLocation } from 'react-router-dom';
import { getUserInfo, logout } from '../utils/auth';
import './Dashboard.css';

const Header = ({ displayName }) => {
  const userInfo = getUserInfo();
  const location = useLocation();
  const isLoginPage = location.pathname === '/';
  
  let initials = 'U';
  if (userInfo?.given_name && userInfo?.family_name) {
    initials = `${userInfo.given_name.charAt(0).toUpperCase()}.${userInfo.family_name.charAt(0).toUpperCase()}`;
  }
  return (
    <header className="dashboard-header" style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 32px', minHeight: '140px', position: 'relative', background: '#fff', zIndex: 2}}>
      {/* Avatar e Welcome solo se NON siamo nella pagina di login */}
      {!isLoginPage && (
  <div className="header-user" style={{display: 'flex', alignItems: 'center', gap: '1rem', position: 'relative', zIndex: 30}}>
          <div className="user-avatar" style={{width: '54px', height: '54px', borderRadius: '50%', background: '#eaf2ff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: '1.5rem', color: '#4a7cff'}}>
            {initials}
          </div>
          <div style={{display: 'flex', flexDirection: 'column'}}>
            <div className="welcome-text" style={{fontSize: '1.15rem', fontWeight: 600, color: '#4a7cff', marginBottom: '0.3rem'}}>
              Welcome {displayName}
            </div>
            <button
              className="action-button b1"
              style={{minWidth: '120px', marginTop:'0.5rem', zIndex: 40, position: 'relative'}}
              onClick={() => {
                window.dispatchEvent(new CustomEvent('dashboard-profile-click'));
              }}
            >
              Profile
            </button>
          </div>
        </div>
      )}
      <div className="header-logo-centered" style={{flex: 1, display: 'flex', justifyContent: 'center', position: 'relative', minHeight: '70px', background: '#fff'}}>
        <img src={process.env.PUBLIC_URL + '/logo_profesia.png'} alt="Profesia Logo" style={{height: '90px', width: '240px', margin: '0 auto', position: 'relative', zIndex: 2, background: 'transparent', borderRadius: '0', boxShadow: 'none', border: 'none'}} />
      </div>
      {!isLoginPage && (
        <div className="header-logout" style={{marginLeft: 'auto'}}>
          <button className="logout-button" onClick={logout}>
            Logout
          </button>
        </div>
      )}
    </header>
  );
};

export default Header;
